import clsx from 'clsx';

import { useBasket } from '~/features/basket/hooks/useBasket';
import { SearchDialogContent } from '~/features/search/components/SearchDialogContent/SearchDialogContent';
import { useSearchState } from '~/features/search/hooks/useSearchState';
import { useWishlist } from '~/features/wishlist/hooks/useWishlist';
import Bag from '~/icons/bag.svg';
import Heart from '~/icons/heart.svg';
import Pin from '~/icons/pin.svg';
import Search from '~/icons/search.svg';
import { Dialog as SearchDialog } from '~/shared/components/Dialog/Dialog';
import Link from '~/shared/components/Link/Link';
import { VisuallyHidden } from '~/shared/components/VisuallyHidden/VisuallyHidden';
import { useNavigation } from '~/shared/utils/navigation/hooks/useNavigation';
import { isBrowser } from '~/shared/utils/platform';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import styles from './mainMenuHotLinks.module.css';

const MainMenuHotLinks = () => {
	const { translate } = useTranslation();
	const {
		data: { header: { favorites, findStores, basket } = {} },
	} = useNavigation();
	const { data: { quantitySum: basketItemsCount = 0 } = {} } = useBasket();
	const { data: { items: itemsWishList = [] } = {} } = useWishlist();
	const {
		isDialogOpen: isSearchOpen,
		openDialog: openSearch,
		closeDialog: closeSearch,
	} = useSearchState(({ isDialogOpen, openDialog, closeDialog }) => ({
		isDialogOpen,
		openDialog,
		closeDialog,
	}));

	const openSearchDialog = () => {
		if (isBrowser) {
			window.document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
		}

		openSearch();
	};

	return (
		<div className={styles.root}>
			<SearchDialog
				withOverlay
				open={isSearchOpen}
			>
				<button
					className={styles.button}
					onClick={openSearchDialog}
					aria-label={translate('search.menu-label')}
				>
					<Search />
					<span className={styles.searchLabel}>{translate('search.menu-label')}</span>
				</button>
				<SearchDialogContent onCloseClick={closeSearch} />
			</SearchDialog>

			{favorites ? (
				<Link
					className={clsx(styles.link, styles.hideOnMobile)}
					href={favorites.url}
					title={favorites.title}
				>
					<Heart />
					<VisuallyHidden>{favorites.text}</VisuallyHidden>
					<span className={styles.count}>{itemsWishList.length}</span>
				</Link>
			) : null}

			{findStores ? (
				<Link
					className={clsx(styles.link, styles.hideOnMobile)}
					href={findStores.url}
					title={findStores.title}
				>
					<Pin />
					<VisuallyHidden>{findStores.text}</VisuallyHidden>
				</Link>
			) : null}

			{basket ? (
				<Link
					className={styles.link}
					href={basket.url}
					title={basket.title}
				>
					<Bag />
					<span className={styles.count}>{basketItemsCount}</span>
					<VisuallyHidden>{basket.text}</VisuallyHidden>
				</Link>
			) : null}
		</div>
	);
};

export default MainMenuHotLinks;
